//useGlobalFunctions.js

/**
 * FIREBASE
 */

export const isFirebaseStorageURL = (imageUrl) => {
        // Check if imageUrl is null or undefined
        if (!imageUrl) {
            return false; // Return false if imageUrl is null or undefined
          }
        
          const firebaseStorageKeywords = [
            "firebasestorage.googleapis.com",
            "o/",
            "alt=media",
            "token=",
          ];
        
          // Check if all the Firebase Storage keywords are present in the URL
          return firebaseStorageKeywords.every(keyword => imageUrl.includes(keyword));
  };
  
export const getDomainWithHttps = () => {
      const protocol = window.location.protocol; // Example: "http:" or "https:"
      const hostname = window.location.hostname; // Example: "www.example.com" or "localhost"
      const port = window.location.port; // Example: "8080"
    
      const domainWithHttps = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
      return domainWithHttps;
};

export const formatMoneyWithSpaces = (price) => {
  var formattedPrice = parseFloat(price).toFixed(2);
  formattedPrice = formattedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return formattedPrice;
};


export const getWeekNumber = (d) => {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};


export const formatTimestamp = (timestamp) => {
  const ts = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
  
  const day = ts.getDate().toString().padStart(2, "0");
  const month = ts.toLocaleString("default", { month: "short" });
  const time = ts.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return `${day} ${month} · ${time}`;
};

export const getCountdownString = (expiryDate) => {
  const now = new Date();
  const end = new Date(expiryDate);
  const diff = end - now;
  if (diff <= 0) return 'expired';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const mins = Math.floor((diff / (1000 * 60)) % 60);
  const secs = Math.floor((diff / 1000) % 60);

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0 || days > 0) parts.push(`${hours}h`);
  if (mins > 0 || hours > 0 || days > 0) parts.push(`${mins}m`);
  parts.push(`${secs}s`);

  return parts.join(' ');
};

export const formatDuration = (minutes) => {
  if (!minutes) return '0min';
  
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  
  if (hours === 0) {
    return `${minutes}min${minutes !== 1 ? 's' : ''}`;
  }
  
  if (remainingMinutes === 0) {
    return `${hours}hr${hours !== 1 ? 's' : ''}`;
  }
  
  return `${hours}hr${hours !== 1 ? 's' : ''} ${remainingMinutes}min${remainingMinutes !== 1 ? 's' : ''}`;
};


//////////////////////////////////